import Routes from '@core/routes/Routes';
import ContainerLayout from '@shared/layouts/ContainerLayout';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const App: React.FC = () => {
  const url = useLocation().pathname;
  const isPortal = url.split('/')[1] === 'portal';

  useEffect(() => {
    document.documentElement.classList.toggle('portal-page', isPortal);
    return () => document.documentElement.classList.remove('portal-page');
  }, [isPortal]);

  let admin: any = localStorage.getItem('admin');

  return (
    <div className="h-[100vh]">
      {!isPortal ? (
        <Routes />
      ) : !admin ? (
        <Routes />
      ) : (
        <ContainerLayout>
          <Routes />
        </ContainerLayout>
      )}
    </div>
  );
};

export default App;
